module.exports = __webpack_public_path__ + "/images/cover-elige-compact-es.90fade8.svg";